import ToastContent from './ToastContent';

export default ToastContent;
